module.exports = __webpack_public_path__ + "22_tvcg.jpg?57f683fea0f9eb0fd2cc772d4ecef32e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/22_tvcg.jpg
// module id = 189
// module chunks = 0